import React from 'react'
import { Tabs, type TabsProps } from '@mantine/core'

export type AppTabsProps = TabsProps

function AppTabsRoot (props: AppTabsProps) {
  return <Tabs {...props} />
}

const AppTabs = Object.assign(AppTabsRoot, {
  List: Tabs.List,
  Tab: Tabs.Tab,
  Panel: Tabs.Panel
})

export default AppTabs
